<template>
  <div :class="[ 'well', severity ]">
    <slot></slot>
  </div>
</template>

<script>
export default {
  props: {
    severity: { type: String, default: '' },
  },
};
</script>

<style scoped>
.well {
  padding: 15px 25px;
  margin: 5px;

  background-color: rgba(200,200,200,0.2);
  border-radius: 5px;
  border: 1px solid rgba(200,200,200,0.4);
  box-shadow: inset 0 1px 2px 0px rgba(0,0,0,.25);
}

.well.information {
  background-color: rgba(66,139,202,0.2);
  border: 1px solid #428bca;
}

.well.warning {
  background: rgba(255,68,17,0.2);
  border: 1px solid #ff4411;
}
</style>



// WEBPACK FOOTER //
// src/components/elements/Well.vue